import React, { useRef, useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import useAccessibilityClick from '../../hooks/useAccessibilityClick';
import scoringService from '../services/ScoringService';
import { register } from '../../i18n';

const t = register('TeacherScoringPanel');

const AiSuggestedScoreButton = observer(({ lessonElementId, customLabel } = {}) => {
  const { responseManager } = useContext(MobXProviderContext);
  const lessonElementState = responseManager.getLessonElementState(lessonElementId);
  const aiSuggestedScoreButtonRef = useRef();

  useAccessibilityClick(aiSuggestedScoreButtonRef, async (event) => {
    await scoringService.setToAiSuggestedScore(lessonElementId);

    // Reset flag - scores now match AI
    lessonElementState.setHasChangedFromAiScore(false);
  });

  // Only show button if hasChangedFromAiScore is a boolean (meaning it's an AI-scored item)
  if (typeof lessonElementState.hasChangedFromAiScore !== 'boolean') {
    return null;
  }

  const buttonLabel = customLabel || t('aiSuggestedScore');

  return (
    <button
      ref={aiSuggestedScoreButtonRef}
      aria-label={buttonLabel}
      className={`aiSuggestedScoreButton primary ${lessonElementState.hasChangedFromAiScore ? 'active' : 'disabled'}`}
      disabled={!lessonElementState.hasChangedFromAiScore}
    >
      <div aria-hidden className='label'>
        {buttonLabel}
      </div>
    </button>
  );
});

export default AiSuggestedScoreButton;
